import React from "react";
import classnames from "classnames";
import eyeIcon from "../../../assets/images/show-password.svg";
import { FormGroup, FormControl, HelpBlock } from "react-bootstrap";
import styles from "./Input.scss";

class Input extends React.Component {
  constructor() {
    super();

    this.state = {
      showPass: false,
      focus: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => {
      return { showPassword: !prevState.showPassword };
    });
  }

  render() {
    const {
      showPasswordIcon,
      defaultValue,
      input,
      type,
      placeholder,
      formGroupClassName,
      name,
      forceError,
      help,
      validationType,
      meta: { touched, error, warning, valid },
      ...props
    } = this.props;

    const validationState =
      validationType === "website" && input.value === ""
        ? null
        : (((touched && error) || forceError) && "error") ||
          (touched && valid && "success") ||
          (touched && warning && "warning") ||
          null;

    const feedback = showPasswordIcon ? (
      <img
        className={styles.showPass}
        src={eyeIcon}
        onClick={this.handleClick}
      />
    ) : (
      <FormControl.Feedback className={styles.inputFeedback} />
    );

    let visible = true;
    if (
      this.props.floatingPlaceholder != undefined &&
      this.props.floatingPlaceholder == false &&
      input.value != ""
    ) {
      visible = false;
    }
    return (
      <FormGroup
        validationState={validationState}
        className={formGroupClassName}
      >
        <div className={styles.relativeClass}>
          {visible && (
            <label
              onClick={() => this.input.focus()}
              className={classnames({
                [styles.placeholderFloat]: true,
                [styles.placeholderFloatActive]: input.value
              })}
            >
              {placeholder}
            </label>
          )}
          <FormControl
            inputRef={ref => {
              this.input = ref;
            }}
            type={this.state.showPassword ? "text" : type}
            defaultValue={defaultValue}
            id={input.name}
            value={input.value}
            name={name}
            onChange={input.onChange}
            className={classnames({
              [styles.input]: true,
              [styles.inputFocus]: input.value && visible
            })}
            onBlur={input.onBlur}
            autoFocus={this.props.autoFocus || false}
            {...props}
          />
          {help && <HelpBlock className={styles.help}>{help}</HelpBlock>}
          {touched && error && <p className={styles.error}>{error}</p>}
          {feedback}
        </div>
      </FormGroup>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/input/Input.js